import { Injectable } from '@angular/core';
import { Y42FeatureType } from '@y42/json-schema';
import { Observable } from 'rxjs';
import { DatasourceTableStoreModel, DatasourceTableUIModel } from './datasource-table.model';
import { DatasourceTableQuery } from './datasource-table.query';

@Injectable()
export abstract class AllDatasourceTablesQuery implements Partial<Omit<DatasourceTableQuery, 'selectAll'>> {
  abstract readonly loading$: Observable<boolean>;
  abstract readonly tables$: Observable<DatasourceTableUIModel[]>;
  abstract readonly active$: Observable<DatasourceTableUIModel>;
  abstract readonly activeItems$: Observable<DatasourceTableUIModel[]>;
  abstract readonly featureType: Y42FeatureType;

  abstract selectAll(): Observable<DatasourceTableStoreModel[]>;
  abstract selectUIEntity(tableId: string): Observable<DatasourceTableUIModel | undefined>;
  abstract getEntity(tableId: string): DatasourceTableStoreModel | undefined;
  abstract getUIEntity(tableId: string): DatasourceTableUIModel | undefined;
}
